function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { SpinnerReact } from 'common/components/spinner';
import { SpinnerSize } from 'common/components/spinner/types';
import { useExperimentsStore } from 'apps/experiments/src/store';
import { ContentPage } from 'common/content/page';
import { useQueryExperiment } from '../hooks/query-experiment';
import { useExperimentBookmarkSync } from '../hooks/bookmark-sync';
import { storeMetricResults } from '../hooks/metric-results';
import { useSyncResults } from '../hooks/sync-results';
import { useStagedExperiment } from '../hooks/staged-experiment';
import { useExperimentPageContext } from '../context';
import { ExperimentPageMain } from './main';
import { ExperimentPageConfiguration } from './configuration';
export function ExperimentPageContent() {
  const {
    projectId,
    workspaceId,
    userId,
    experimentId,
    featureFlagIntegrationEnabled
  } = useExperimentPageContext();
  const {
    hasStagedChanges,
    commitExperiment,
    revertExperiment
  } = useStagedExperiment();
  const experiment = useExperimentsStore(state => state.experiment);
  const setExperiment = useExperimentsStore(state => state.setExperiment);
  const experimentLoading = useExperimentsStore(state => state.experimentLoading);
  const setCurrentMetric = useExperimentsStore(state => state.setCurrentMetric);
  useExperimentBookmarkSync({
    projectId,
    experimentId: experimentId!
  });
  const onClickPageBackground = React.useCallback(() => {
    setCurrentMetric(undefined);
  }, [setCurrentMetric]);
  storeMetricResults({
    projectId,
    workspaceId,
    experimentId: experimentId!
  });
  useSyncResults();
  useQueryExperiment({
    projectId,
    workspaceId,
    experimentId: experimentId!,
    featureFlagIntegrationEnabled
  });
  if (!experiment || experimentLoading) {
    return <SpinnerReact size={SpinnerSize.Large} />;
  }
  return <ContentPage content={experiment} projectId={projectId} workspaceId={workspaceId} userId={userId} onClick={onClickPageBackground} hasUnsavedChanges={hasStagedChanges} onCommit={commitExperiment} onRevert={revertExperiment} onUpdate={content => setExperiment(_objectSpread(_objectSpread({}, experiment), content))} data-sentry-element="ContentPage" data-sentry-component="ExperimentPageContent" data-sentry-source-file="_content.tsx">
      <ExperimentPageMain data-sentry-element="ExperimentPageMain" data-sentry-source-file="_content.tsx" />
      <ExperimentPageConfiguration data-sentry-element="ExperimentPageConfiguration" data-sentry-source-file="_content.tsx" />
    </ContentPage>;
}